var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TemplateRef, ChangeDetectorRef, ElementRef } from '@angular/core';
import { PerfilComponent } from '../perfil/perfil.component';
import { PropiedadService } from 'src/app/services/propiedad.service';
import { UserService } from 'src/app/services/user.service';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GLOBAL } from 'src/app/services/global';
import { Http } from '@angular/http';
import { Store } from '@ngrx/store';
import { FormControl, Validators } from '@angular/forms';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
var TotemBusquedaDireccionComponent = /** @class */ (function () {
    function TotemBusquedaDireccionComponent(_snackBar, dialog, store, _user, spinner, _cd, http, elementRef, _prop, _router, claveUnicaService) {
        var _this = this;
        this._snackBar = _snackBar;
        this.dialog = dialog;
        this.store = store;
        this._user = _user;
        this.spinner = spinner;
        this._cd = _cd;
        this.http = http;
        this.elementRef = elementRef;
        this._prop = _prop;
        this._router = _router;
        this.claveUnicaService = claveUnicaService;
        this.errorMessage = '';
        this.displayedColumns = ['PDI_Direc_Completa'];
        this.buscando = false;
        this.rol = new FormControl('', [Validators.required]);
        this.calle = new FormControl('', [Validators.required]);
        this.nroCalle = new FormControl('', [Validators.required]);
        this.comunaMapa = GLOBAL.nombreMuni;
        this.ubicacion = '';
        this.sitio = '';
        this.manzana = '';
        this.zonaprc = '';
        this.conjHabit = '';
        this.aup = '';
        this.locaciones = [];
        this.markers = [];
        this.marcadores = [];
        this.bandera = false;
        this.calleform = new FormControl("");
        this.dires = [];
        //asdasd  //para en guardar el nombre de la primera direccion
        //coordenadas del centro de peñaflor //la florida
        this.lat = -33.60627; //-33.53071445
        this.lng = -70.87649; //-70.54402715
        this.nombreMarker = '';
        //console.log(this.rol)
        this.spinner.show();
        this.map = google.maps.Map;
        this._prop.getCalles().subscribe(function (response) {
            _this.calles = response.calles;
            _this.bandera = true;
            _this.spinner.hide();
        }, function (error) {
            console.log(error);
            // this.spinner.hide()
        });
        this.identity = this._user.getIdentity();
        this.token = this._user.getToken();
        /*   if (sessionStorage.getItem('identity-domCloud')) {
              this.searchUser()
            }else {
              this._router.navigate(['/inicio'])
              swal({
                type: 'warning',
                title: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
              })
            } */
    }
    TotemBusquedaDireccionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.filteredOptions = this.calle.valueChanges.pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    TotemBusquedaDireccionComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.calles.filter(function (option) { return option.toLowerCase().indexOf(filterValue) === 0; });
    };
    TotemBusquedaDireccionComponent.prototype.buscar = function (rol, calle, num) {
        var _this = this;
        var dirs = [];
        this.spinner.show();
        if (this.rol.valid) {
            this._user.get_direccion_rol(this.rol.value).subscribe(function (response) {
                if (response.status == "error") {
                    _this.spinner.hide();
                    console.log(response.message);
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(function () {
                    }, function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    });
                }
                else {
                    if (response.rescompleta.response.data.length > 1) {
                        for (var i = 0; i < response.rescompleta.response.data.length; i++) {
                            var element = response.rescompleta.response.data[i].fieldData;
                            _this.dires.push(element);
                        }
                        _this.dialog.open(_this.direccionesDialog, { disableClose: true });
                        _this.spinner.hide();
                    }
                    else {
                        _this.rol_busqueda = _this.rol.value;
                        _this._cd.detectChanges();
                        if (response.rescompleta.response.data.length > 0) {
                            for (var x = 0; x < response.rescompleta.response.data.length; x++) {
                                var element = response.rescompleta.response.data[x].fieldData;
                                var defaultObj = {
                                    'PDI_Direc_Completa': response.rescompleta.response.data[x].fieldData['PDI_Direc_Completa']
                                };
                                dirs.push(defaultObj);
                                var defaultObj2 = {
                                    'PDI_Calle_Nombre': response.rescompleta.response.data[x].fieldData['PDI_Calle_Nombre'],
                                    'PDI_Num_Calle': response.rescompleta.response.data[x].fieldData['PDI_Num_Calle']
                                };
                                _this.markers.push(defaultObj2);
                            }
                            _this.direcciones = new MatTableDataSource(dirs);
                        }
                        else {
                            var defaultObjX = {
                                'PDI_Direc_Completa': ""
                            };
                            dirs.push(defaultObjX);
                            _this.markers.push(defaultObjX);
                            _this.direcciones = new MatTableDataSource(dirs);
                        }
                        //console.log("va bien: ",response.rescompleta,  dirs)
                        _this.inforol = response;
                        _this.ubicacion = response.res.fieldData['Propiedad::Pro_Propie_Ubicacion'];
                        _this.manzana = response.res.fieldData['Propiedad::Pro_Propie_Manzana'];
                        _this.sitio = response.res.fieldData['Propiedad::Pro_Propie_Sitio'];
                        if (_this.marcadores.length > 0) {
                            _this.marcadores = [];
                        }
                        _this._user.get_predio(_this.rol_busqueda).subscribe(function (resultado) {
                            _this.zonaprc = resultado.res.response.data[0].fieldData['Pro_Propie_Zona_Edif'];
                            _this.conjHabit = resultado.res.response.data[0].fieldData['Conj_Habit::CONJ_Nombre_Completo'];
                            _this.aup = resultado.res.response.data[0].fieldData['Pro_Propie_Afecta'];
                            if (_this.manzana == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'] != "") {
                                _this.manzana = resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'];
                            }
                            if (_this.sitio == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'] != "") {
                                _this.sitio = resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'];
                            }
                            //console.log('get_predio',resultado)
                        });
                        //this.markers = dirs
                        _this.createMap();
                        _this.buscando = true;
                        _this.spinner.hide();
                    }
                }
            }, function (error) {
                console.log(error);
                _this.spinner.hide();
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
                _this.spinner.hide();
            });
        }
        else if (this.calle.valid && this.nroCalle.valid) {
            this._user.get_direccion_callenum(this.calle.value, this.nroCalle.value).subscribe(function (response) {
                if (response.status == "error") {
                    _this.spinner.hide();
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(function () {
                    }, function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    });
                    _this.calle.setValue("");
                    _this.nroCalle.setValue("");
                }
                else {
                    if (response.res.response.data.length > 1) {
                        for (var i = 0; i < response.res.response.data.length; i++) {
                            var element = response.res.response.data[i].fieldData;
                            _this.dires.push(element);
                        }
                        _this.dialog.open(_this.direccionesDialog, { disableClose: true });
                        _this.spinner.hide();
                    }
                    else {
                        //console.log("busqueda por calle y nro: ", response.rol)
                        _this.rol_busqueda = response.rol;
                        _this._user.get_direccion_rol(_this.rol_busqueda).subscribe(function (response) {
                            //this.rol_busqueda = this.rol.value                    
                            _this._cd.detectChanges();
                            if (response.rescompleta.response.data.length > 0) {
                                for (var x = 0; x < response.rescompleta.response.data.length; x++) {
                                    var element = response.rescompleta.response.data[x].fieldData;
                                    var defaultObj = {
                                        'PDI_Direc_Completa': response.rescompleta.response.data[x].fieldData['PDI_Direc_Completa']
                                    };
                                    dirs.push(defaultObj);
                                    var defaultObj2 = {
                                        'PDI_Calle_Nombre': response.rescompleta.response.data[x].fieldData['PDI_Calle_Nombre'],
                                        'PDI_Num_Calle': response.rescompleta.response.data[x].fieldData['PDI_Num_Calle']
                                    };
                                    _this.markers.push(defaultObj2);
                                }
                                _this.direcciones = new MatTableDataSource(dirs);
                            }
                            else {
                                var defaultObjX = {
                                    'PDI_Direc_Completa': ""
                                };
                                dirs.push(defaultObjX);
                                _this.markers.push(defaultObjX);
                                _this.direcciones = new MatTableDataSource(dirs);
                            }
                            _this.inforol = response;
                            _this.ubicacion = response.res.fieldData['Propiedad::Pro_Propie_Ubicacion'];
                            _this.manzana = response.res.fieldData['Propiedad::Pro_Propie_Manzana'];
                            _this.sitio = response.res.fieldData['Propiedad::Pro_Propie_Sitio'];
                            if (_this.marcadores.length > 0) {
                                _this.marcadores = [];
                            }
                            _this._user.get_predio(_this.rol_busqueda).subscribe(function (resultado) {
                                _this.zonaprc = resultado.res.response.data[0].fieldData['Pro_Propie_Zona_Edif'];
                                _this.conjHabit = resultado.res.response.data[0].fieldData['Conj_Habit::CONJ_Nombre_Completo'];
                                _this.aup = resultado.res.response.data[0].fieldData['Pro_Propie_Afecta'];
                                if (_this.manzana == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'] != "") {
                                    _this.manzana = resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'];
                                }
                                if (_this.sitio == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'] != "") {
                                    _this.sitio = resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'];
                                }
                                //console.log('get_predio',resultado)
                            });
                            //this.markers = dirs
                            _this.createMap();
                            _this.buscando = true;
                            _this.spinner.hide();
                        }, function (error) {
                            _this.spinner.hide();
                            console.log(error);
                        });
                    }
                }
            }, function (error) {
                _this.spinner.hide();
                console.log(error);
                _this.errorMessage = JSON.parse(error._body);
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            });
        }
    };
    TotemBusquedaDireccionComponent.prototype.insertarDir = function () {
        var _this = this;
        this.spinner.show();
        this._cd.detectChanges();
        var dirs = [];
        this.rol_busqueda = this.dirSeleccionada['Propiedad::Pro_Propie_ROL'];
        // if (this.dirSeleccionada.length > 0) {
        // for (let x = 0; x < this.dirSeleccionada.length; x++) {
        //     const element = this.dirSeleccionada;
        var defaultObj = {
            'PDI_Direc_Completa': this.dirSeleccionada['PDI_Direc_Completa']
        };
        dirs.push(defaultObj);
        var defaultObj2 = {
            'PDI_Calle_Nombre': this.dirSeleccionada['PDI_Calle_Nombre'],
            'PDI_Num_Calle': this.dirSeleccionada['PDI_Num_Calle']
        };
        this.markers.push(defaultObj2);
        // }
        this.direcciones = new MatTableDataSource(dirs);
        // } else {
        //     var defaultObjX = {
        //         'PDI_Direc_Completa': ""
        //     }
        //     dirs.push(defaultObjX)
        //     this.markers.push(defaultObjX)
        //     this.direcciones = new MatTableDataSource(dirs)
        // }
        this.inforol = this.dirSeleccionada;
        this.ubicacion = this.dirSeleccionada['Propiedad::Pro_Propie_Ubicacion'];
        this.manzana = this.dirSeleccionada['Propiedad::Pro_Propie_Manzana'];
        this.sitio = this.dirSeleccionada['Propiedad::Pro_Propie_Sitio'];
        if (this.marcadores.length > 0) {
            this.marcadores = [];
        }
        this._user.get_predio(this.dirSeleccionada['Propiedad::Pro_Propie_ROL']).subscribe(function (resultado) {
            _this.zonaprc = resultado.res.response.data[0].fieldData['Pro_Propie_Zona_Edif'];
            _this.conjHabit = resultado.res.response.data[0].fieldData['Conj_Habit::CONJ_Nombre_Completo'];
            _this.aup = resultado.res.response.data[0].fieldData['Pro_Propie_Afecta'];
            if (_this.manzana == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'] != "") {
                _this.manzana = resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'];
            }
            if (_this.sitio == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'] != "") {
                _this.sitio = resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'];
            }
            //console.log('get_predio',resultado)
        });
        //this.markers = dirs
        this.dialog.closeAll();
        this.createMap();
        this.buscando = true;
        this.spinner.hide();
    };
    TotemBusquedaDireccionComponent.prototype.mapInitializer = function () {
        this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
    };
    TotemBusquedaDireccionComponent.prototype.centerChange = function (event) {
        //console.log(event);
    };
    TotemBusquedaDireccionComponent.prototype.ChangeMap = function (event) {
        //console.log(event);
    };
    TotemBusquedaDireccionComponent.prototype.getGeolocation = function (dirSimb, dirReal) {
        var _this = this;
        var dataLatLng;
        //crear servicio nomatim 
        //console.log("https://nominatim.openstreetmap.org/search.php?q="+address+"%20la%20florida%20santiago&polygon_geojson=1&format=jsonv2")
        //let geocoder = "https://nominatim.openstreetmap.org/search.php?q="+address+"%20la%20florida%20santiago&polygon_geojson=1&format=jsonv2"
        dataLatLng = this.http.get("https://nominatim.openstreetmap.org/search.php?q=" + dirSimb + "%20" + this.comunaMapa + "&polygon_geojson=1&format=jsonv2").subscribe(function (datos) {
            //asdasd=JSON.stringify(datos);
            //dataLatLng=eval(datos);//JSON.stringify(datos);
            try {
                console.log("datos de nomatim : ", datos);
                //console.log("datos de respuestas desde nominatim: ",JSON.parse(datos['_body']))
                dataLatLng = JSON.parse(datos['_body']);
                if (dataLatLng == '[]') {
                    console.log("objeto vacio");
                }
                else {
                    _this.lat = parseFloat(dataLatLng[0]['lat']);
                    _this.lng = parseFloat(dataLatLng[0]['lon']);
                    console.log(dirSimb, _this.lat + " " + _this.lng);
                    //this.nombreMarker = dirSimb.replace("%20", " ")
                    var nuevoMarcador = new Marcador(_this.lat, _this.lng, dirReal);
                    //guarda latitud, longitud y nombre para los marker del mapa
                    _this.marcadores.push(nuevoMarcador);
                }
                /***********************/
            }
            catch (error) {
                console.log(error, datos);
            }
        });
    };
    TotemBusquedaDireccionComponent.prototype.createMap = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                //location
                this.markers.forEach(function (element) {
                    //cambiar 
                    var nomCalle = element['PDI_Calle_Nombre'] + ' ' + element['PDI_Num_Calle'] + ' ' + GLOBAL.nombreMuni;
                    var geocoder = new google.maps.Geocoder;
                    geocoder.geocode({ address: nomCalle, }, function (resy, status) {
                        if (status === 'OK') {
                            _this.locaciones.push(resy[0].geometry.location);
                        }
                        else {
                            console.log('GeocoderMarker failed due to: ' + status, nomCalle);
                        }
                    }, function (error) {
                        console.log(error);
                    });
                    /* let dataCalle = element['PDI_Calle_Nombre'].replace(" ", "%20")
                    dataCalle = dataCalle.replace(/\n|\r|\r\n/g, "%20")
        
                    this.getGeolocation(dataCalle+'%20'+element['PDI_Num_Calle']+ '%20Rancagua', element['PDI_Calle_Nombre']+' '+element['PDI_Num_Calle']) */
                });
                setTimeout(function () {
                    //las coordenadas iniciales son del centro de peñaflor
                    _this.mapOptions = google.maps.MapOptions = {
                        center: { lat: -33.60627, lng: -70.87649 },
                        zoom: 14,
                        scaleControl: true
                    };
                    _this.mapInitializer();
                    var bounds = new google.maps.LatLngBounds();
                    _this.markers.forEach(function (element, ind) {
                        var nomCalle = element['PDI_Calle_Nombre'] + ' ' + element['PDI_Num_Calle'];
                        //new google.maps.LatLng(locations[i][1], locations[i][2]),
                        var markerx = new google.maps.Marker({
                            position: _this.locaciones[ind],
                            map: _this.map,
                            title: nomCalle,
                        });
                        bounds.extend(markerx.position);
                        _this.attachSecretMessage(markerx, nomCalle);
                    });
                    _this.map.fitBounds(bounds);
                    //console.log("marcadores: ",this.marcadores[0].lat, this.marcadores[0].lng, this.marcadores[0].titulo)
                }, 4000);
                return [2 /*return*/];
            });
        });
    };
    TotemBusquedaDireccionComponent.prototype.attachSecretMessage = function (marker, secretMessage) {
        var infowindow = new google.maps.InfoWindow({
            content: secretMessage,
        });
        marker.addListener("click", function () {
            infowindow.open(marker.get("map"), marker);
        });
    };
    TotemBusquedaDireccionComponent.prototype.volver = function () {
        this.buscando = false;
        this.rol.setValue("");
        this.calle.setValue("");
        this.nroCalle.setValue("");
        this.deleteMarkers();
    };
    TotemBusquedaDireccionComponent.prototype.deleteMarkers = function () {
        //this.clearMarkers();
        this.markers = [];
    };
    TotemBusquedaDireccionComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    TotemBusquedaDireccionComponent.prototype.openPerfil = function () {
        this.dialog.open(PerfilComponent);
    };
    TotemBusquedaDireccionComponent.prototype.back = function () {
        this._router.navigate(['/inicio']);
    };
    TotemBusquedaDireccionComponent.prototype.searchUser = function () {
        var _this = this;
        /* Buscar si existe en fm */
        var identityData = this._user.getIdentity();
        var rut = identityData.rut + identityData.dv;
        this._user.buscarUsuario(rutClean(rut)).subscribe(function (response) {
            if (response.message) {
                _this.spinner.hide();
                console.log(response);
            }
            if (response.register) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
            if (response.update) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return TotemBusquedaDireccionComponent;
}());
export { TotemBusquedaDireccionComponent };
var Marcador = /** @class */ (function () {
    function Marcador(lat, lng, titulo) {
        this.titulo = 'Sin titulo';
        this.lat = lat;
        this.lng = lng;
        this.titulo = titulo;
    }
    return Marcador;
}());
export { Marcador };
